exports.list = {
    path: '/stok_inventory_teknisi',
    name: 'stok_inventory_teknisi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/stok_inventory_teknisi/List.vue"),
}
exports.show = {
    path: '/stok_inventory_teknisi/show/:id',
    name: 'stok_inventory_teknisi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/stok_inventory_teknisi/Show.vue"),
}